import { AssetType } from '@peritasai/types';

export const DISCOVERABLE_ASSET_TYPES = [
  AssetType.TRAY,
  AssetType.EQUIPMENT,
  AssetType.IMPLANT,
  AssetType.CASE_CART,
];

export enum AssignToCaseStep {
  LOADING_LOCATIONS = 'loading-locations',
  SELECT_LOCATION = 'select-location',
  ERROR_LOCATIONS = 'error-locations',
  LOADING_CASES = 'loading-cases',
  SELECT_CASE = 'select-case',
  ERROR_CASES = 'error-cases',
  LOADING_HUB = 'loading-hub',
  HUB_OFFLINE = 'hub-offline',
  HUB_IN_USE = 'hub-in-use',
  SUCCESS = 'success',
}

export type AssignToCaseCase = {
  id: string;
  caseId: string;
  timeLabel: string;
  surgeonName: string;
  procedureName: string;
  scheduledDateTime: Date;
  durationMinutes: number | null;
};

export type AssignToCaseSelectionLabels = {
  featureTitle: string;
  locationListTitle: string;
  caseListTitle: string;
  selectButtonLabel: string;
  changeLocationButtonLabel: string;
  viewAllLocationsLabel: string;
  hideAdditionalLocationsLabel: string;
  viewAllCasesLabel: string;
  hideAdditionalCasesLabel: string;
  noCasesMessage: string;
};

export type { DetectedAsset } from '../../discovery/types';
